import React from "react";
import "./skeleton.scss";

const NewsListSkeleton = () => {
  return (
    <div className="news-container skeleton-container">
      {/* 左侧列骨架屏 */}
      <div className="news-column left-column">
        {[1, 2].map((item) => (
          <div key={item} className="news-card skeleton">
            <div className="news-image shimmer"></div>
            <div className="news-info">
              <div className="news-category shimmer"></div>
              <div className="news-title shimmer"></div>
              <div className="news-source shimmer"></div>
            </div>
          </div>
        ))}
      </div>

      {/* 中间列骨架屏 */}
      <div className="news-column center-column">
        <div className="news-card large skeleton">
          <div className="news-image shimmer"></div>
          <div className="news-info">
            <div className="news-category shimmer"></div>
            <div className="news-title shimmer"></div>
            <div className="news-desc shimmer"></div>
          </div>
        </div>
      </div>

      {/* 右侧列骨架屏 */}
      <div className="news-column right-column">
        <div className="column-header shimmer"></div>
        {[1, 2, 3, 4].map((item) => (
          <div key={item} className="news-card small skeleton">
            <div className="news-info">
              <div className="news-tag shimmer"></div>
              <div className="news-title shimmer"></div>
              <div className="news-source shimmer"></div>
            </div>
            <div className="news-thumbnail shimmer"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsListSkeleton;
